<p>daily-summary-report works!</p>
